import React from 'react';
import {
  Box,
  Typography,
  Paper,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Divider,
} from '@mui/material';
import SentimentVeryDissatisfiedIcon from '@mui/icons-material/SentimentVeryDissatisfied';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import ErrorIcon from '@mui/icons-material/Error';
import { VChainerFooter } from '../../../app/components/VChainerFooter';
import { useAppSelector } from '../../../app/hooks';
import { selectSettings } from '../../settings/settingsSlice';


const texts = {
    title: {
        pl: 'Dziękujemy za skorzystanie z systemu V-Chainer',
        en: 'Thank you for using the V-Chainer system',
        de: 'Vielen Dank, dass Sie V-Chainer nutzen',
    },
    list: {
        resignationSent: {
            pl: 'Rezygnacja z komentowania została przekazana klientowi.',
            en: 'Your resignation from commenting has been sent to the client.',
            de: 'Ihr Verzicht auf die Kommentierung wurde dem Kunden mitgeteilt.',
        },
        noComment: {
            pl: 'Nie skomentowałeś dokumentu.',
            en: 'You did not comment on the document.',
            de: 'Sie haben das Dokument nicht kommentiert.',
        },
        noCommentNote: {
            pl: 'Jeśli zmienisz zdanie, możesz skontaktować się z klientem lub naszym zespołem, aby uzyskać dostęp ponownie.',
            en: 'If you change your mind, you can contact the client or our team to regain access.',
            de: 'Wenn Sie es sich anders überlegen, wenden Sie sich an den Kunden oder unser Team, um erneut Zugang zu erhalten.',
        },
    },
};


const ResignationConfirmationPanel: React.FC = () => {
  const { locale } = useAppSelector(selectSettings);
  const lang = locale === 'en-US' ? 'en' : locale;

  return (
    <Box
      display="flex"
      justifyContent="center"
      alignItems="center"
      minHeight="100vh"
      bgcolor="#f4f6f8"
      p={2}
    >
      <Paper elevation={4} sx={{ p: 5, maxWidth: 650, borderRadius: 3, textAlign: 'center' }}>
        <SentimentVeryDissatisfiedIcon sx={{ fontSize: 64, color: 'warning.main', mb: 2 }} />

        <Typography variant="h5" gutterBottom>
          {texts.title[lang]}
        </Typography>

        <List sx={{ textAlign: 'left', mb: 3 }}>
          <ListItem>
            <ListItemIcon>
              <CheckCircleIcon color="success" />
            </ListItemIcon>
            <ListItemText primary={texts.list.resignationSent[lang]} />
          </ListItem>

          <ListItem>
            <ListItemIcon>
              <ErrorIcon color="error" />
            </ListItemIcon>
            <ListItemText
              primary={texts.list.noComment[lang]}
              secondary={texts.list.noCommentNote[lang]}
            />
          </ListItem>
        </List>
        <Divider />
        <VChainerFooter />
      </Paper>
    </Box>
  );
};

export default ResignationConfirmationPanel;
